import api from "@/api/api-v2-config";

export async function getDesignationListAxios() {    
    return await api.get("hrms/designations?PageNumber=1&PageSize=10000");
}

export async function deleteDesignationAxios(id) {    
    return await api.delete("hrms/designations?DesignationId=" + id);
}

export async function postDesignationAxios(designation) {    
    return await api.post("hrms/designations", designation);
}

export async function putDesignationAxios(designation) {    
    return await api.put("hrms/designations", designation);
}

export async function getDesignationByIDAxios(id) {    
    return await api.get("designation/" + id);
}